import { render, staticRenderFns } from "./AssistanceShare.vue?vue&type=template&id=4e2b9278&scoped=true&lang=html&"
import script from "./AssistanceShare.vue?vue&type=script&lang=js&"
export * from "./AssistanceShare.vue?vue&type=script&lang=js&"
import style0 from "./AssistanceShare.vue?vue&type=style&index=0&id=4e2b9278&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2b9278",
  null
  
)

export default component.exports